import React from 'react';
import PropTypes from 'prop-types';
import Actions from 'components/ui/general/Actions';
import Breadcrumbs from 'components/layout/Layout/Breadcrumbs';
import Card from 'components/ui/card/Card';
import CardText from 'components/ui/card/CardText';
import Header from 'components/ui/general/Header';
import ListButton from 'components/button/ListButton';
import PropertiesEditForm from './PropertiesEditForm';
import Title from 'components/ui/general/Title';
import compose from 'recompose/compose';
import fetchResourceAndLocalisationById from 'components/hoc/fetchResourceAndLocalisationById';
import translate from 'components/hoc/translate';
import utils from 'helpers/utils';
import { connect } from 'react-redux';
import { fetchProperty } from 'store/actions/properties/fetchProperties';
import { updateProperty } from 'store/actions/properties/updateProperties';
import ResourceNotFound from 'pages/NotFound/ResourceNotFound';
import LoadingCard from 'components/loading/LoadingCard';

class PropertiesEditContainer extends React.Component {
    formatFormResults = (values) => {
        const {
            system,
        } = this.context.config.language;

        let baseValues = {
            property_group_id: values.property_group_id,
            ...values.localisation[system],
        };

        const localisationValues = utils.filterEmptyValues(values.localisation);

        return {
            base: baseValues,
            localisation: localisationValues,
            system: {
                property_group_id: values.property_group_id,
            },
        };
    }

    handleSubmitForm = (values) => {
        const {
            dispatchForm,
            history,
            id,
        } = this.props;

        if (utils.isEmpty(values)) {
            return null;
        }

        const convertedValues = this.formatFormResults(values);

        return new Promise((resolve, reject) => {
            return dispatchForm({
                onError: () => {
                    reject();
                },
                onSuccess: () => {
                    resolve(history.push(`/properties/${ id }/show`));
                },
                formValues: convertedValues,
                id: id,
            });
        });
    }

    render() {
        if (!this.props.localisation) {
            return null;
        }

        const {
            data,
            localisation,
            resourceFetchLoading,
            resourceFetchFailed,
            translate,
        } = this.props;

        if (resourceFetchLoading) {
            return <LoadingCard />;
        }

        if (resourceFetchFailed) {
            return <ResourceNotFound />;
        }

        const breadcrumbs = [
            {
                label: translate('resources.properties.title'),
                link: '/properties',
            },
            {
                label: data.name,
                link: `/properties/${ data.id }/show`,
            },
            {
                label: translate('actions.edit'),
            },
        ];

        return (
            <div>
                <Breadcrumbs breadcrumbs={ breadcrumbs } />

                <Header>
                    <Title title={ translate('resources.properties.actions.edit') } />

                    <Actions>
                        <ListButton url='/properties' />
                    </Actions>
                </Header>

                <Card>
                    <CardText>
                        <PropertiesEditForm
                            data={ data }
                            localisation={ localisation }
                            form='properties_edit'
                            handleSubmitForm={ this.handleSubmitForm }
                        />
                    </CardText>
                </Card>
            </div>
        );
    }
}

PropertiesEditContainer.contextTypes = {
    config: PropTypes.object,
};

PropertiesEditContainer.propTypes = {
    data: PropTypes.object,
    dispatchForm: PropTypes.func.isRequired,
    history: PropTypes.object,
    id: PropTypes.number,
    localisation: PropTypes.object,
    resourceFetchFailed: PropTypes.bool.isRequired,
    resourceFetchLoading: PropTypes.bool.isRequired,
    translate: PropTypes.func.isRequired,
};

const mapDispatchToProps = (dispatch) => {
    return {
        dispatchForm: (values) => {
            dispatch(updateProperty(values));
        },
    };
};

const enhance = compose(
    translate,
    connect(
        null,
        mapDispatchToProps,
    ),
    fetchResourceAndLocalisationById({
        action: fetchProperty,
        resource: 'properties',
    })
);

export default enhance(PropertiesEditContainer);



// WEBPACK FOOTER //
// ./src/pages/properties/edit/PropertiesEditContainer.js